// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","container":"_1UHCEb9UsmLXJuyhIWQFsv"};